import { Client, fetchExchange } from "@urql/core";
import createDataProvider from "@refinedev/graphql";
import { GetListParams } from "@refinedev/core";
import { mapLocalPropertyToApiPath, mapToApiStudent } from "@/utils/mappers";
import { StudentSchemaType } from "@schema/zod/student";
import { SchoolYearSchemaType } from "@schema/zod/schoolYear";
import { getAccessToken } from "@/lib/httpClient";

const API_URL = process.env.NEXT_PUBLIC_GRAPHQL_URL || "http://localhost:3200/graphql";

// Create GraphQL client with auth headers
const gqlClient = new Client({
  url: API_URL,
  exchanges: [fetchExchange],
  fetchOptions: () => {
    const token = getAccessToken();
    return {
      headers: {
        Authorization: token ? `Bearer ${token}` : "",
      },
    };
  },
});

export const gqldataProvider = createDataProvider(gqlClient, {
  getList: {
    dataMapper: (response, params) => {
      const resourceName = params.resource;
      return response.data?.[resourceName]?.getAll || [];
    },
    getTotalCount: (response, params) => {
      const resourceName = params.resource;
      return response.extensions?.total?.[resourceName] || 0;
    },
    buildVariables: (params: GetListParams) => {
      const { pagination, sorters, resource, filters } = params;
      const result: Record<string, any> = {
        perPage: pagination?.pageSize || 5,
        page: pagination?.current || 1,
      };

      ///

      switch (resource) {
        case 'student':
          if (sorters?.length) {
            result.sortField = mapLocalPropertyToApiPath(sorters[0].field);
            result.sort = sorters[0].order?.toUpperCase();
          }

          if (filters?.length) {
            result.filters = filters.reduce((obj: Record<string, any>, elem) => {
              const field = mapLocalPropertyToApiPath((elem as any).field);
              if (!field) return obj;
              if (!obj[field]) obj[field] = [];

              obj[field].push({
                value: elem.value,
                operator: elem.operator,
              });

              return obj;
            }, {});
          }

          return {
            ...result,
          };
      }

      if (sorters?.length) {
        result.sortField = sorters[0].field;
        result.sort = sorters[0].order?.toUpperCase();
      }

      ///

      return result;
    },
  }
});